import { useEffect, useRef, useState } from 'react';

import './Options.css';

export function Options({ children }: React.PropsWithChildren) {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement | null>(null);

    const toggleMenu = () => {
        setMenuOpen((prev) => !prev);
    };

    const handleClickOutside = (event: MouseEvent) => {
        if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
            setMenuOpen(false);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <div className='relative flex items-center'>
            <button onClick={toggleMenu} className='size-[20px] bg-[image:var(--options-icon-svg)] bg-contain' />
            {menuOpen && (
                <div ref={menuRef} className='options-menu'>
                    {children}
                </div>
            )}
        </div>
    );
}
